import { Injectable } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, distinctUntilKeyChanged, filter, map, switchMap, tap } from 'rxjs/operators';

import { DateTime } from '../../_core/date';
import { notNull } from '../../_core/rxjs.operators';
import { AuthService } from '../../_services/auth/auth.service';
import { ProductModel } from '../../_sdk/products/product.model';
import { ProductEnum } from '../../_sdk/products/product.enum';

declare let Intercom: Function;
type IntercomUser = { email: string, user_id: string, name: string, v4UserRole:string, v4ODHVAC: boolean, v4Submeter: boolean  };
let userRoles =[
    'Administrators',
    'PropertyManager',
    'BuildingEngineer',
    'TenantManager',
    'TenantUser',
    'AmrbUser'
]

@Injectable({
    providedIn: 'root'
})
export class IntercomService {
    private _isBooted: boolean = false;

    private readonly _user$ = new BehaviorSubject<IntercomUser>(null);
    
    constructor(private readonly authService: AuthService) {
        this.authService.authenticatedUser$
            .pipe(
                tap(p => {
                    let role = this.getRole(p?.UserRoles || [])
                    const { v4ODHVAC, v4Submeter } = this.getProducts(p?.Context?.Products || []);
                    this._user$.next({
                        user_id: p && p.UserGuid,
                        email: p && p.Email,
                        name: p 
                            ? `${p.FirstName} ${p.LastName}`
                            : '',
                        v4UserRole:role,
                        v4ODHVAC,
                        v4Submeter

                        
                    });
                })
            )
            .subscribe();
    }
    public getRole(roleArray){
        let sysNameArray = []
        roleArray.forEach(element => {
            sysNameArray.push(element.SystemName)
        });
        for(let i of userRoles){
            if(sysNameArray.includes(i)){
                return i;
            }
        }
        return ''
    }

    public getProducts(products: ProductModel[]): { v4ODHVAC: boolean; v4Submeter: boolean } {
        const hasHVAC = products.some(p => p.Id === ProductEnum.OvertimeHVAC);
        const hasSubmeter = products.some(p => p.Id === ProductEnum.SubmeterBillding);
        
        return {
            v4ODHVAC: hasHVAC,
            v4Submeter: hasSubmeter
        };
    }    

    public initialize(router: Router): this {
        this._user$
            .pipe(
                notNull(),
                distinctUntilKeyChanged('user_id'),
                tap(user => {

                    if(user.user_id && !this._isBooted) {
                        console.log('intercom: boot');

                        Intercom('boot', {
                            app_id: 'xngrqpmt',
                            created_at: DateTime.now().toDate().getTime(),
                            'v4WebPlatformUser': true,
                            ...user
                        });

                        this._isBooted = true;
                        this.checkIfMobile();
                    } else if(this._isBooted) {
                        console.log('intercom: shutdown');

                        Intercom('shutdown');

                        this._isBooted = false;
                    }
                }),
                switchMap(user => {
                    return router.events
                        .pipe(
                            map(event => event as RouterEvent),
                            map(event => event && event.url),
                            filter(url => !String.isNullOrEmpty(url)),
                            distinctUntilChanged(),
                            tap(url => {
                                if(this._isBooted) {
                                    console.log('intercom: update');
                                    Intercom('update', {
                                        url,
                                        ...user
                                    });
                                }
                            })
                        )
                })
            )
            .subscribe();

        return this;
    }
    public openIntercomChat(){
        Intercom("show");
    }
    // Hides/restores the floating chat launcher, e.g. while a side panel would sit under it.
    public setLauncherHidden(hidden: boolean){
        if(!this._isBooted){
            return;
        }

        Intercom('update', {
            "hide_default_launcher": hidden
        });

        if(!hidden){
            this.checkIfMobile();
        }
    }
    private checkIfMobile(){
        if(window.innerWidth<960){
            Intercom('update', {
                "hide_default_launcher": true
            });
        }
    }
}
